import React from 'react';

export const BlockTraining = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'block-training' */
            './BlockTraining'
        ),
);
